var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"panel"},[_c('p',{staticClass:"panel-heading specific_color"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"panel-block"},[_c('div',{staticClass:"center"},[_c('p',{staticClass:"info"},[_vm._v(_vm._s(_vm.text))]),_c('img',{staticClass:"images",attrs:{"src":_vm.address,"alt":"picture"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }